export enum InsureIQLgmCommodityTypeNames {
  FARROW_TO_FINISH = 'Farrow to Finish',
  FINISHING_OPERATION = 'Finishing Operation',
  SEW_OPERATION = 'SEW Operation',
  CALF_FINISHING = 'Calf Finishing',
  YEARLING_FINISHING = 'Yearling Finishing',
}
